import React from 'react';
import { ReactComponent as GripIcon } from '../../../resources/assets/components/grip.svg';
function DraggableGrip({ height }) {
    const style = {
        height,
        top: -height,
    };
    return (React.createElement("div", { className: "c-floating-panel__draggable-grip", style: style },
        React.createElement(GripIcon, null)));
}
export default DraggableGrip;
//# sourceMappingURL=draggable-grip.js.map